import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TrustBar from "./sections/TrustBar";
import Destinations from "./sections/Destinations";
import HowItWorks from "./sections/HowItWorks";
import Confidence from "./sections/Confidence";
import Fleet from "./sections/Fleet";
import Testimonials from "./sections/Testimonials";
import TravelCare from "./sections/TravelCare";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <TrustBar />
      <Destinations />
      <HowItWorks />
      <Confidence />
      <Fleet />
      <Testimonials />
      <TravelCare />
      <Faq />
      <Footer />
    </div>;
}